import React from 'react';

const WebhookResponse = ({ rowData }) => {
  return (
    <div className="overflow--auto npn-info-json p--sm bg--black radius--sm h--full w--full text--white">
      <pre>
        <code>{JSON.stringify(rowData, null, 2)}</code>
      </pre>
    </div>
  );
};

export default WebhookResponse;
